import type { FeatureTiersResponse } from "~/types/api/workspace/feature-tiers"

export function useFeatureTiers() {
  const { $api } = useNuxtApp()

  return useFetch<FeatureTiersResponse>("/admin/v1/workspace/feature-tiers", {
    $fetch: $api,
    key: "workspace-feature-tiers",
    dedupe: "defer",
    getCachedData: (key, nuxtApp) =>
      nuxtApp.payload.data[key] ?? nuxtApp.static.data[key],
  })
}
